import React from "react";
import { Switch, Route } from "react-router-dom";

import AuthLayout from "../auth/AuthLayout";
import AppLayout from "../app/AppLayout";

const NotFound = () => <h1>Not Found</h1>;

const Layouts = () => {
  return (
    <Switch>
      <Route path="/auth" component={AuthLayout} />
      <Route path="/app" component={AppLayout} />
      <Route path="/" component={AuthLayout} />
    </Switch>
  );
};

export default Layouts;
